import { DomHelpers } from '../core/DomHelpers.js';
import { DEFAULT_NS, executeOnItems } from '../core/imcmd/types.js';
import { Widget } from '../core/Widget.js';
import { FilterUiCommand } from './FilterUiCommand.js';
import { FILTER_WIDGET_KEY } from './types.js';

/**
 * Провайдер UI-команд для FilterWidget (namespace = "filter").
 */
class FilterUiCommandProvider {
    constructor() {
        /** Идентификатор провайдера */
        this.id = "FilterWidget";
        /** Пространство имён провайдера */
        this.namespace = "filter";
        /** Приоритет среди провайдеров одного NS */
        this.priority = 10;
        /** Разрешён вызов без префикса (DEFAULT_NS) */
        this.defaultNSAllowed = true;
    }
    /**
     * Исполняет команды управления ViewWidget.
     * Алгоритм: проверка NS/команды → цели (targetItems | маска в rawArgs[0] | fallback) → executeOnItems.
     * @param token Токен UI-команды
     * @param ctx Контекст выполнения
     */
    execute(token, ctx) {
        const nsOk = token.namespace === this.namespace
            || (this.defaultNSAllowed && token.namespace === DEFAULT_NS);
        if (!nsOk)
            return false;
        const cmd = token.command || "";
        // Здесь при необходимости можно ограничить мультирежим для отдельных команд (выбрасывать ошибку).
        return executeOnItems(token, ctx, (el) => {
            switch (cmd) {
                /** Свернуть / развернуть группу фильтров */
                // filter::closeFilter|<mask>
                case FilterUiCommand.toggleGroup: {
                    const [mask] = token.rawArgs ?? [];
                    let group;
                    let container;
                    if (!mask) {
                        // Маска не передана, значит считаем что кнопка расположена стандартно
                        group = ctx.sourceEl.closest('.modal-aside__group');
                        container = ctx.sourceEl.parentElement?.nextElementSibling;
                    }
                    else {
                        // Для режима извне - должно указывать на контейнер который будет прятаться
                        container = el;
                        group = el.closest('.modal-aside__group');
                    }
                    if (group && container) {
                        const active = group.classList.toggle('active');
                        if (active) {
                            DomHelpers.show(container);
                        }
                        else {
                            DomHelpers.hide(container);
                        }
                    }
                    return true;
                }
                /** Закрыть фильтр */
                // filter::closeFilter|<mask>
                case FilterUiCommand.closeFilter: {
                    const [mask] = token.rawArgs ?? [];
                    let filter;
                    if (!mask) {
                        // Маска не передана, значит ищем ближайший фильтр
                        filter = Widget.closestOnByName(ctx.sourceEl, FILTER_WIDGET_KEY);
                    }
                    else {
                        filter = Widget.closestOnByName(el, FILTER_WIDGET_KEY);
                    }
                    filter?.close();
                    return true;
                }
                /** Очистить поля фильтра */
                // filter::clearFilter|<mask>|<keys=<key1,key2,...>
                case FilterUiCommand.clearFilter: {
                    const [mask, keys] = token.rawArgs ?? [];
                    let filter;
                    if (!mask) {
                        // Маска не передана, значит ищем ближайший фильтр
                        filter = Widget.closestOnByName(ctx.sourceEl, FILTER_WIDGET_KEY);
                    }
                    else {
                        filter = Widget.closestOnByName(el, FILTER_WIDGET_KEY);
                    }
                    if (filter) {
                        if (keys === 'chips') {
                            filter.clearChips();
                        }
                        else if (keys) {
                            const keysArr = String(keys)
                                .split(',')
                                .map(k => k.trim())
                                .filter(Boolean);
                            filter.clearKeys(keysArr);
                        }
                        else {
                            filter.clearAll();
                        }
                    }
                    return true;
                }
                default:
                    return false;
            }
        });
    }
}

export { FilterUiCommandProvider };
